import { inject, Injectable, signal } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BrowserUtilService {
  private readonly breakpointObserver = inject(BreakpointObserver);

  isHandset = signal(false);

  constructor() {
    this.breakpointObserver
      .observe(Breakpoints.Handset)
      .pipe(map((result) => result.matches))
      .subscribe((isHandset) => this.isHandset.set(isHandset));
  }

  isSafari(): boolean {
    return navigator.userAgent.includes('Chrome') === false && navigator.userAgent.includes('Safari');
  }

  isIframe(): boolean {
    return window !== window.parent && !window.opener;
  }
}
